export default __webpack_public_path__ + "static/media/angbao-bonus-cny.8e7d2f22.webp";